<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30 z-51"
    @click.self="closeModal"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[450px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden">
          <div class="flex flex-col p-[20px] gap-[22px] bg-[#FCFCFC]">
            <div class="h-[74px] flex flex-col items-center">
              <ResourcesIcon class="w-[50px] h-[50px] text-[#9B237B]" />
              <span class="PC_Body1-SB !text-[#1F1D1F]">
                อัปเดตยอดที่ได้รับ
              </span>
            </div>
            <div
              class="max-h-[490px] flex flex-col gap-[14px] px-[10px] py-[14px] pr-[16px] rounded-[6px] border-[1px] border-solid border-[#b7b2b5] bg-[#fff] overflow-auto"
            >
              <div class="flex flex-col gap-[8px]">
                <div class="flex items-start gap-[6px]">
                  <div
                    class="min-w-[72px] min-h-[72px] w-[72px] h-[72px] border-[1px] border-solid border-[#F2E7F9]"
                  >
                    <img
                      :src="item.image_path || 'https://placehold.co/48x48/png'"
                      alt=""
                    />
                  </div>
                  <div>
                    <div class="PC_Body1-R !text-[#1F1D1F]">
                      {{ item.name }}
                    </div>
                    <div class="cardLabel">
                      {{ item.unit_name }}
                    </div>
                    <div class="cardLabel">
                      {{ item.category_name }}
                    </div>
                  </div>
                </div>
                <div class="w-full h-[1px] bg-[#DFDCDD]"></div>
                <div class="flex gap-[4px] PC_Body2-R text-[#1F1D1F]">
                  <span> จำนวนที่ต้องการปัจจุบัน </span>
                  <span>:</span>
                  <span v-if="item.request != '-1.00'">
                    {{ $numberAndComma(item.request) || "0" }}
                  </span>
                  <span v-else> ไม่จำกัด </span>
                </div>
                <div class="flex gap-[4px] PC_Body2-R text-[#1F1D1F]">
                  <span> ยอดที่ได้รับ </span>
                  <span>:</span>
                  <span>
                    {{ $numberAndComma(item.quantity) || "0" }}
                  </span>
                </div>
              </div>
              <div class="flex flex-col gap-[10px]">
                <div
                  class="flex items-center gap-[6px] p-[4px] px-[6px] bg-[#FBEFF8]"
                >
                  <span class="title"> อัปเดตยอดที่ได้รับ </span>
                  <!-- <div class="title !text-[#EB5554]">*</div> -->
                </div>
                <div class="flex flex-col gap-[6px]">
                  <div class="PC_Body2-R text-[#1F1D1F]">
                    เพิ่ม จำนวนที่ได้รับ
                  </div>
                  <QuantitySelectorComponent
                    v-if="item.request != '-1.00'"
                    :inputClass="'!h-[42px] !min-w-[104px]'"
                    :disabled="form.unit_type == 1"
                    :maxValue="totalLeft"
                    v-model:fieldValue="form.quantity"
                  />
                  <QuantitySelectorComponent
                    v-else
                    :inputClass="'!h-[42px] !min-w-[104px]'"
                    :disabled="form.unit_type == 1"
                    v-model:fieldValue="form.quantity"
                  />
                </div>
              </div>
              <div class="flex flex-col gap-[10px]">
                <div
                  class="flex items-center gap-[6px] p-[4px] px-[6px] bg-[#FBEFF8]"
                >
                  <span class="title"> แหล่งที่มา </span>
                  <!-- <div class="title !text-[#EB5554]">*</div> -->
                </div>
                <div class="flex flex-col gap-[14px]">
                  <div class="flex flex-col gap-[10px]">
                    <Radio
                      :id="'resources_choice1'"
                      v-model="form.detail.type"
                      :name="'resources_choice1'"
                      :value="1"
                      :label="'ศูนย์พักพิง'"
                    />
                    <div class="pl-[30px]">
                      <SelectBoxComponent
                        :inputId="'shelter_id'"
                        :searchable="true"
                        :allowEmpty="true"
                        :keyValue="'id'"
                        :keyName="'name'"
                        :options="AllShelter"
                        :value="form.detail.shelter_id"
                        :placeholder="'เลือกศูนย์พักพิง'"
                        :disabled="form.detail.type == 2"
                        :allData="true"
                        @update:modelValue="
                          (res) => {
                            form.detail.shelter_id = res?.id || '';
                            form.detail.shelter_name = res?.name || '';
                          }
                        "
                      />
                    </div>
                  </div>
                  <div class="flex flex-col gap-[10px]">
                    <Radio
                      :id="'resources_choice1'"
                      v-model="form.detail.type"
                      :name="'resources_choice1'"
                      :value="2"
                      :label="'อื่นๆ'"
                    />
                    <div class="pl-[30px]">
                      <Input
                        placeholder="ระบุ"
                        v-model="form.detail.other"
                        :disabled="form.detail.type == 1"
                        :warningMessage="errors.unit_type"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="flex items-center gap-[6px] p-[4px] px-[6px] bg-[#FBEFF8]"
                >
                  <span class="title"> รายละเอียด อื่นๆ </span>
                </div>
                <div class="flex flex-col gap-[14px]">
                  <Input
                    label="Lot no. (ถ้ามี)"
                    placeholder="Lot no. (ถ้ามี)"
                    v-model="form.detail.lot_no"
                  />
                  <!-- datePicker  -->
                  <DatePicker2
                    :containerClass="'w-[calc(33%-0rem)]'"
                    label="วันผลิต/วันหมดอายุ (ถ้ามี)"
                    :id="'birthDate1'"
                    placeholder="เลือกวันเดือนปี"
                    :modelValue="form.detail.exp_date"
                    :isMaxDate="false"
                    @update:modelValue="(date) => selectDate(date)"
                  />
                  <!-- datePicker  -->
                </div>
                <Input
                  label="หมายเหตุ (ถ้ามี)"
                  placeholder="หมายเหตุ (ถ้ามี)"
                  v-model="form.detail.reason"
                />
              </div>
            </div>
            <div class="flex items-center justify-center gap-[10px]">
              <ButtonComponent
                :label="'ยกเลิก'"
                :bClass="'btn_shadow--cancel'"
                @clicked="closeModal"
              />
              <ButtonComponent
                :label="'บันทึก'"
                :bClass="'btn_shadow--save'"
                :disabled="
                  form.quantity == 0 ||
                  (form.detail.other == '' && form.detail.shelter_id == '')
                "
                @clicked="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import { useGlobals } from "@/components/Utilities/javascripts/useGlobals";
import { useProductStore } from "@/pinia/product";
import { useShelterStore } from "@/pinia/shelter";
import { storeToRefs } from "pinia";

const { $validateMsg } = useGlobals();
const productStore = useProductStore();
const shelterStore = useShelterStore();
const { AllShelter } = storeToRefs(shelterStore);

const emptyDetail = () => ({
  type: 1,
  shelter_name: "",
  shelter_id: "",
  other: "",
  lot_no: "",
  exp_date: "",
  reason: "",
});

const emptyForm = () => ({
  product_id: "",
  request: "0",
  quantity: "0",
  detail: emptyDetail(),
});

// const input = emptyForm();

const form = ref(emptyForm());
const errors = ref(emptyForm());
const item = ref({});
const modalIsOpened = ref(false);

const emit = defineEmits(["status", "update"]);

watch(
  () => form.value.detail.type,
  (val) => {
    if (val === 2) {
      form.value.detail.shelter_id = "";
    } else if (val === 1) {
      form.value.detail.other = "";
    }
  },
  { immediate: true }
);

const totalQuantity = computed(() => {
  const formQty = parseFloat(form.value.quantity) || 0;
  const itemQty = parseFloat(item.value.quantity) || 0;
  return formQty + itemQty;
});

const totalLeft = computed(() => {
  const req = parseFloat(form.value.request) || 0;
  const qty = parseFloat(item.value.quantity) || 0;
  return req - qty;
});

const resetForm = () => {
  form.value = emptyForm();
  errors.value = emptyForm();
};

const openModal = (data) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  resetForm();

  item.value = data;
  form.value.request = item.value.request;
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const save = async () => {
  const body = {
    ...form.value,
    id: item.value.id,
    status: 1,
    request: form.value.request,
    quantity: form.value.quantity,
    total: totalQuantity.value,
  };
  if (body.request == body.total) {
    const message =
      "จำนวนที่ระบุ ครบตามจำนวนที่ร้องขอแล้ว \n หากทำการบันทึก คำขอนี้จะถูกยุติลง \n และเก็บเข้าประวัติ ท่านต้องการที่จะบันทึกหรือไม่";
    emit("status", message, "warning", "บันทึก", body, "update");
  } else {
    await productStore
      .updateProductRequest(body)
      .then((response) => {
        if (response.status === 200) {
          emit("status", response.data.message, "success");
          emit("update");
          closeModal();
        }
      })
      .catch((error) => {
        if (error.status === 400) {
          emit("status", error.response.data.message, "error");
        } else {
          $validateMsg(error.response.data.errors, errors.value);
        }
      });
  }
};

const selectDate = (date) => {
  form.value.detail.exp_date = date;
};

defineExpose({ openModal, closeModal });
</script>
    
<style lang="scss" scoped>
.title {
  color: #1f1d1f;
  /* fields/title */
  font-family: Kanit;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.1px;
}
@media screen and (max-width: 64rem) {
  .PC_Body1-R {
    font-size: 16px !important;
  }
}
</style>